import {List} from "../Common/Elements/List";
import {Task} from "../../types/farming";
import {TaskEntry} from "./TaskEntry";
import {useTranslation} from "react-i18next";


export function TaskList({tasks} : {tasks : Task[]}) {
    const presortedTasks = tasks.sort((a, b) => a.order_rank - b.order_rank)
    const notClaimedTasks = presortedTasks.filter(e => e.status !== "Claimed")
    const claimedTasks = presortedTasks.filter(e => e.status === "Claimed")
    const sortedTasks = notClaimedTasks.concat(claimedTasks)
    const {t} = useTranslation()

    return <div className="friends-view-list" style={{height: "calc(var(--app-height) - 13.8rem)"}}>
        <div className="flex-y-center small-margin-bottom">
            <span className="list-header small-margin"> {t("tasks")} </span>
        </div>
        <List
            createElement={e => <TaskEntry task={e}/>}
            collection={sortedTasks}
            elementHeight={70}
            id={"list-friends"}
        />
    </div>
}